import {Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {FilterService} from '../../../services/filter.service';

@Component({
  selector: 'app-filter-clear-all-button',
  templateUrl: './filter-clear-all-button.component.html',
  styleUrls: ['./filter-clear-all-button.component.scss'],
  standalone: true,
  imports: [MatButtonModule],
})
export class FilterClearAllButtonComponent {
  filterService = inject(FilterService);
}
